(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brezo-blog-post"]) return;
  try {
    
  // Generate Table of Contents from H2 headings
  document.addEventListener("DOMContentLoaded", function() {
    const content = document.querySelector(".brezo-article__content");
    const toc = document.getElementById("table-of-contents");
    if (!content || !toc) return;

    const headings = content.querySelectorAll("h2");
    if (headings.length === 0) {
      const sidebar = document.getElementById("article-sidebar");
      if (sidebar) sidebar.style.display = "none";
      // Make content full width
      const layout = document.querySelector(".brezo-article__layout");
      if (layout) layout.style.gridTemplateColumns = "1fr";
      return;
    }

    headings.forEach(function(h, i) {
      const id = "section-" + i;
      h.id = id;
      const a = document.createElement("a");
      a.href = "#" + id;
      a.textContent = h.textContent;
      toc.appendChild(a);
    });

    // Reading time
    const text = content.textContent || "";
    const wordCount = text.trim().split(/\s+/).length;
    const minutes = Math.max(1, Math.round(wordCount / 200));
    const readingEl = document.getElementById("reading-time");
    if (readingEl) readingEl.textContent = minutes + " min lectura";

    // Active TOC on scroll
    const tocLinks = toc.querySelectorAll("a");
    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          tocLinks.forEach(function(l) { l.classList.remove("active"); });
          const activeLink = toc.querySelector("a[href=\"#" + entry.target.id + "\"]");
          if (activeLink) activeLink.classList.add("active");
        }
      });
    }, { rootMargin: "-100px 0px -70% 0px" });

    headings.forEach(function(h) { observer.observe(h); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
